import {Component, forwardRef, SimpleChanges, Input, ChangeDetectorRef, Injector, ElementRef, ViewChild, HostListener} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, Validators } from '@angular/forms';
import { InventoryInputModel, Enum_SoudotecInventoryInputModeScan } from '../inventory-input.model';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { InventoryInputService } from '../inventory-input.service';
import { MatDialog } from '@angular/material/dialog';
import { InventoryInputArticlesDialog } from '../inventory-input-articles-dialog/inventory-input-articles-dialog.component';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { Model_SoudotecDocument, Model_SoudotecDocumentLigne } from '../../soudotec.models';

enum KEY_CODE {
  UP_ARROW = 38,
  DOWN_ARROW = 40,
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37
}

@Component({
    selector: 'abw-inventory-input-form',
    providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InventoryInputFormComponent),
          multi: true
      },
      {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => InventoryInputFormComponent),
          multi: true
      }
    ],
    templateUrl: './inventory-input-form.component.html',
    styleUrls: ['./inventory-input-form.component.scss']
})
export class InventoryInputFormComponent extends AbstractWorkflowFormComponent<InventoryInputModel, any> {
  @Input() modeScan: Enum_SoudotecInventoryInputModeScan;
  Enum_SoudotecInventoryInputModeScan = Enum_SoudotecInventoryInputModeScan;
  itemsScanned: any[] = [];
  articles: any[] = [];
  component: Model_WorkflowComponent;
  valueName: string;
  displayName: string;
  qrCodeName: string;
  showAlert = false;
  msgAlert = '';
  @ViewChild('itemsContainer') itemsContainer: ElementRef;

  constructor(
    private dialog: MatDialog,
    private _inventoryInputService: InventoryInputService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.component = this.model.additional as Model_WorkflowComponent;
    this.articles = this.component.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS;
    this.valueName = this.component.VALUE_COLUMN_NAME;
    this.displayName = this.component.DISPLAY_COLUMN_NAME;
    this.qrCodeName = (this.component as any).QRCODE_COLUMN_NAME;
  }

  doOpenArticlesDialog() {
    const dialogRef = this.dialog.open(InventoryInputArticlesDialog, {
      data: { 
        datas: this.articles, 
        valueName: this.valueName,
        displayName: this.displayName,
      },
      width: '100vw',
      panelClass: 'datasource-designer-modal'
    });
    
    dialogRef.afterClosed().subscribe((refArticle?: string) => {
        if (refArticle === undefined) { return; }
        const articleIndex = this.articles.findIndex(a => a[this.valueName] === refArticle);
        if (articleIndex === -1) { return; }
        this.addItemToInventory(this.articles[articleIndex]);
    });
  }

  addItemToInventory(_article: any) {
    var item: any = {};
    item.AR_Ref = _article[this.valueName];
    item.AR_Design = _article[this.displayName];
    item.BARCODE_SCANNED = _article[this.qrCodeName];
    item.QUANTITE_COMPTEE = 1;

    const itemIndex = this.itemsScanned.findIndex(i => i.AR_Ref == item.AR_Ref);
    if (itemIndex != -1) {
      this.itemsScanned[itemIndex].QUANTITE_COMPTEE = parseFloat(this.itemsScanned[itemIndex].QUANTITE_COMPTEE) + 1;
    } else {
      this.itemsScanned.push(item);
    }
    this._evaluateSoudotecDocument();

    this.itemsContainer.nativeElement.scrollTop = this.itemsContainer.nativeElement.scrollHeight + 100;
  }

  onMinusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE_COMPTEE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE_COMPTEE) - 1;
    this._evaluateSoudotecDocument();
  }

  onPlusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE_COMPTEE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE_COMPTEE) + 1;
    this._evaluateSoudotecDocument();
  }

  onRemoveButtonClicked(_itemIndex: number) {
    this.itemsScanned.splice(_itemIndex, 1);
    this._evaluateSoudotecDocument();
  }

  private _evaluateSoudotecDocument() {
    const articles: Model_SoudotecDocumentLigne[] = this.itemsScanned.map(ligne => ({ 
      cbMarq: ligne.cbMarq, 
      AR_Ref: ligne.AR_Ref, 
      AR_Design: ligne.AR_Design, 
      AR_CodeBarre: ligne.AR_CodeBarre, 
      DL_Qte: ligne.DL_Qte,
      ABW_CodeScanned: ligne.BARCODE_SCANNED,
      ABW_QuantiteSaisie: ligne.QUANTITE_COMPTEE,
    }));
    this.onValueChanged(articles);
  }

  onQteTyped(_event, rowIndex: number) {
    this.itemsScanned[rowIndex].QUANTITE_COMPTEE = _event.detail.value;
    this._evaluateSoudotecDocument();
  }

  onScanned(_scannedCode: string) {
    this.showAlert = false;
    this.msgAlert = '';
    if (_scannedCode == null) { return; }
    if (this.itemsScanned == null) { this.itemsScanned = []; }
    const articleIndex = this.articles.findIndex(a => a[this.qrCodeName] === _scannedCode);
    if (articleIndex === -1) {
      this.msgAlert = `Aucun article ne correspond au code-barres scanné : ${_scannedCode}`;
      this.showAlert = true;
      this._cdf.detectChanges();
      return;
    }
    this.addItemToInventory(this.articles[articleIndex]);
  }
}